<template>
  <section
    v-lenis-scroll
    class="footer"
    :style="{ backgroundImage: 'url(' + backgroundImage + ')' }"
  >
    <div class="overlay" />
    <div class="footer-main">
      <div class="footer-left">
        <img
          class="footersubko"
          :src="shopifyData.stampLogo"
          alt="text_White"
          loading="lazy"
          aria-hidden="true"
          aria-label="Text White"
          width=""
          height=""
        />
      </div>
      <div class="spacer" />
      <div class="spacer" />
      <div style="height: 100vh; display: grid; place-content: center">
        <div class="rightsideimagebox">
          <img
            class="section2rightside"
            :src="shopifyData.logo"
            alt="text_White"
            loading="lazy"
            aria-hidden="true"
            aria-label="Text White"
            width=""
            height=""
          />
          <div class="limitededition">
            <h2 class="sectiontext1">GET YOUR</h2>
            <h2 class="sectiontext2">LIMITED EDITION</h2>
            <h2 class="sectiontext3">BEHNO NEW YORK x SUBKO TOTE BAG</h2>
            <a
              :href="computedHref"
              :data-available="productAvailable"
              class="sourdoughbtn"
              @click="handleClick"
            >
              {{ shopifyData.btnTitle }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    // Dynamic background image based on window width
    backgroundImage() {
      return this.windowWidth <= 676 ? this.shopifyData.mobBg : this.shopifyData.desktopBg;
    },
    productAvailable() {
      return this.shopifyData.isAvailable === 'true' || this.shopifyData.isAvailable === true;
    },
    computedHref() {
      return this.productAvailable ? this.shopifyData.btnLink : '#';
    },
  },
  mounted() {
    gsap.registerPlugin(ScrollTrigger);
    this.setupResponsiveScroll();
    window.addEventListener('resize', this.updateBackgroundImage);
    // window.addEventListener("load", () => {
    //       console.log("Window fully loaded, shopifyData:", this.shopifyData);
    // });
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.updateBackgroundImage);
  },
  methods: {
    handleClick(event) {
      console.log('productAvailable:', this.productAvailable);
      if (!this.productAvailable) {
        event.preventDefault();
      }
    },
    updateBackgroundImage() {
      this.windowWidth = window.innerWidth;
    },
    setupResponsiveScroll() {
      const mm = gsap.matchMedia();
      mm.add('(max-width: 991px)', () => {
        gsap.timeline({
          scrollTrigger: {
            trigger: '.footer-left',
            start: 'top top',
            end: 'center -20%',
            pin: true,
            pinSpacing: false,
            scrub: 3,
          },
        });
      });
    },
  },
};
</script>

<style scoped>
.footer {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  /* height: 300vh; */
  position: relative;
}

.footer-main {
  display: grid;
  grid-template-columns: 1fr 1fr;
  /* height: 100vh; */
  position: relative;
}

.footer-left {
  position: sticky;
  top: 0;
  display: grid;
  place-content: center;
  height: 100vh;
  width: 100%;
  z-index: 4;
}

.sourdoughbtn {
  border: none;
  border-radius: 20px;
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 0.9;
  text-align: center;
  margin-top: 20px;
  background-color: #d9d9d9;
  color: #000000;
  padding: 20px 26px 20px 26px;
  cursor: pointer;
  position: relative;
}

.sourdoughbtn::after {
  content: 'SOLD OUT.';
  border: none;
  border-radius: 20px;
  position: absolute;
  font-family: 'Helvetica Neue', sans-serif;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #d9d9d9;
  font-size: 15px;
  font-weight: 700;
  line-height: 0.9;
  color: #000000;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.sourdoughbtn[data-available='false']:hover::after {
  opacity: 1;
}

.sectiontext1 {
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 13px;
  font-weight: 700;
  line-height: 0.9;
  text-align: center;
  color: #d9d9d9;
}

.sectiontext2 {
  font-family: 'PP Editorial New', sans-serif;
  font-size: 36px;
  font-style: italic;
  font-weight: 200;
  line-height: 0.9;
  text-align: center;
  color: #d9d9d9;
  padding: 10px 0;
}

.sectiontext3 {
  font-family: 'Helvetica Neue', sans-serif;
  font-size: 13px;
  font-weight: 700;
  line-height: 0.9;
  text-align: center;
  color: #d9d9d9;
}

.rightsideimagebox {
  display: flex;
  justify-content: center;
  gap: 100px;
  align-items: center;
  flex-direction: column;
  z-index: 4;
  padding: 0 20px;
}

.subkoscrollrightside {
  position: relative;
  z-index: 9;
  max-width: 430px;
  width: 100%;
  height: 226px;
  margin-top: 100px;
  margin-bottom: 100px;
}

.limitededition {
  border: 1px solid #d9d9d9;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 16px 53px;
  z-index: 4;
}

.overlay {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  background-color: black;
  opacity: 0.3;
  z-index: 1;
}

.footersubko {
  max-width: 524px;
  width: 100%;
}

.section2rightside {
  max-width: 430px;
  width: 100%;
  z-index: 3;
}

.footer-left img {
  max-width: 524px;
  width: 100%;
}

@media screen and (max-width: 500px) {
  .footer-main {
    grid-template-columns: 1fr;
  }

  .footer-left {
    position: static;
    padding-top: 80px;
    place-content: unset;
    justify-items: center;
    height: 100vh;
  }

  .footersubko {
    max-width: 220px;
    width: 100%;
  }

  .sectiontext2 {
    font-size: 20px;
  }

  .sectiontext3 {
    font-size: 10px;
  }

  .sectiontext1 {
    font-size: 12px;
  }

  .sourdoughbtn {
    padding: 11px 12px;
    text-wrap: nowrap;
    font-size: 10px;
  }

  .footer-left img {
    max-width: 220px;
    width: 100%;
  }

  .section2rightside {
    max-width: 220px;
  }
}

@media screen and (max-width: 991px) {
  .sourdoughbtn[data-available='false']::after {
    opacity: 1;
  }

  .footer-main {
    grid-template-columns: 1fr;
  }

  .footer-left {
    position: static;
    place-content: unset;
    justify-items: center;
    padding-top: 78px;
  }

  .spacer {
    display: none;
  }

  .limitededition {
    padding: 13px 33px;
  }
}
</style>
